import React from 'react';
import ReactPlayer from 'react-player';
import { useEffect } from 'react';
import { Helmet } from "react-helmet";
import { SITE_URL } from '../constants';

// const squatAllDegress = 'squat-all-degree.MOV'
const squat0Degree = 'squat-0-degree.MOV'
const squat45Degree = 'squat-45-degree.MOV'
const squat90Degree = 'squat-90-degree.MOV'
const squat135Degree = 'squat-135-degree.MOV'
const squat180Degree = 'squat-180-degree.MOV'

const squats = [
  // {
  //   title: 'Squat - All Degree - with Moving Angle Video',
  //   video: squatAllDegress,
  //   link: '#squat-all-degree'
  // },
  {
    title: 'Squat - 0 Degree - with Shooting Angle Video',
    video: squat0Degree,
    link: '#squat-0-degree'
  },
  {
    title: 'Squat - 45 Degree - with Shooting Angle Video',
    video: squat45Degree,
    link: '#squat-45-degree'
  },
  {
    title: 'Squat - 90 Degree - with Shooting Angle Video',
    video: squat90Degree,
    link: '#squat-90-degree - with Shooting Angle Video'
  },
  {
    title: 'Squat - 135 Degree - with Shooting Angle Video',
    video: squat135Degree,
    link: '#squat-135-degree - with Shooting Angle Video'
  },
  {
    title: 'Squat - 180 Degree - with Shooting Angle Video',
    video: squat180Degree,
    link: '#squat-180-degree'
  },
]

function ProjectETExamples() {

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <React.Fragment>
      <Helmet>
        <title>AI Exercise Detection: Squat Analysis from Multiple Angles | CaptainMe.AI</title>
        <meta name="description" content="Computer vision exercise detection demo: AI-powered squat form analysis from 5 camera angles (0, 45, 90, 135, 180 degrees). Real-time fitness movement tracking by CaptainMe.AI." />
        <meta name="keywords" content="exercise detection AI, squat analysis, computer vision fitness, pose estimation, movement tracking, multi-angle detection" />
        <link rel="canonical" href={`${SITE_URL}/projects/lIlvR9jbBndHw`} />
        <meta property="og:title" content="AI Exercise Detection: Squat Analysis | CaptainMe.AI" />
        <meta property="og:description" content="Computer vision demo: AI-powered squat form analysis from 5 camera angles." />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`${SITE_URL}/projects/lIlvR9jbBndHw`} />
        <meta property="og:image" content={`${SITE_URL}/ogg-captain-me-ai.jpg`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AI Exercise Detection: Squat Analysis | CaptainMe.AI" />
        <meta name="twitter:description" content="AI-powered squat form analysis from 5 camera angles using computer vision." />
        <meta name="twitter:image" content={`${SITE_URL}/ogg-captain-me-ai.jpg`} />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CreativeWork",
          "name": "AI Exercise Detection: Squat Analysis from Multiple Angles",
          "description": "Computer vision demonstration of AI-powered squat form analysis from 5 camera angles using real-time pose estimation and action detection.",
          "url": `${SITE_URL}/projects/lIlvR9jbBndHw`,
          "creator": {
            "@type": "Organization",
            "name": "CaptainMe AI",
            "url": SITE_URL
          },
          "about": {
            "@type": "Thing",
            "name": "Computer Vision Exercise Detection"
          }
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {"@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/`},
            {"@type": "ListItem", "position": 2, "name": "Exercise Detection", "item": `${SITE_URL}/projects/lIlvR9jbBndHw`}
          ]
        })}</script>
      </Helmet>

      {/**
			=============================================
				Theme Inner Banner / Header
			==============================================
      */}
      <div className="theme-inner-banner">
        <div className="container">
          <h2 className="intro-title text-center">Exercise Detection Examples</h2>
        </div>
      </div>

      {/* <!-- 
			=============================================
				Service Details
			============================================== 
			--> */}
      <div className="service-details position-relative mt-30 mb-40">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8 order-lg-1">

              {squats.map((val, index) => {
                const key = `squad-${index}`
                return (


                  <div className='row' key={key}>
                    <div className="service-details-meta ms-xxl-4">
                      <a href={val.link}>
                        <h2 className="sub-title">{val.title}</h2>
                      </a>
                      {/* <p>Exercise Detection Examples</p> */}
                      <div className="row">
                        <ReactPlayer
                          url={`https://captainme-ai.s3.us-west-2.amazonaws.com/project-ed-videos-zHidbjuueU5Xb/${val.video}`}
                          width="40%"
                          height="40%"
                          controls={true}
                          muted={true}
                          pip={false}
                          config={{
                            file: {
                              attributes: {
                                onContextMenu: e => e.preventDefault(),
                                controlsList: 'nodownload nofullscreen noremoteplayback',
                                disablePictureInPicture: true
                              }
                            }
                          }}
                        />
                        <hr />
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default ProjectETExamples;
